import React, { forwardRef } from 'react';
import type { ForwardedRef, ReactNode } from 'react';
import { motion } from 'framer-motion';

import { itemVariants } from '../../IconLinkList.motion';

import './Item.scss';

export interface ItemProps {
    // TODO: This should be optional and processed by a uniqueId factory.
    // However, we will require a unique `key` to be provided in order
    // to satisfy Framer Motion.
    id: string;
    children: ReactNode;
}

function ItemComponent({ id, children }: ItemProps, ref: ForwardedRef<HTMLLIElement>) {
    return (
        <motion.li ref={ref} id={id} className="IconLinkList-Item" variants={itemVariants}>
            {children}
        </motion.li>
    );
}

export const Item = forwardRef(ItemComponent);
